/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Dutch (Netherlands)
export default {
  'navigation.global-shortcuts.all-sites': 'Alle sites',
  'navigation.global-shortcuts.apps.align': 'Uitlijnen',
  'navigation.global-shortcuts.apps.analytics': 'Analyses',
  'navigation.global-shortcuts.apps.assets': 'Assets',
  'navigation.global-shortcuts.apps.bitbucket': 'Bitbucket',
  'navigation.global-shortcuts.apps.company-hub': 'Bedrijfshub',
  'navigation.global-shortcuts.apps.compass': 'Compass',
  'navigation.global-shortcuts.apps.confluence': 'Confluence',
  'navigation.global-shortcuts.apps.focus': 'Focus',
  'navigation.global-shortcuts.apps.goals': 'Doelen',
  'navigation.global-shortcuts.apps.home': 'Startpagina',
  'navigation.global-shortcuts.apps.jira': 'Jira',
  'navigation.global-shortcuts.apps.jira-product-discovery': 'Jira Product Discovery',
  'navigation.global-shortcuts.apps.jira-service-management': 'Jira Service Management',
  'navigation.global-shortcuts.apps.loom': 'Loom',
  'navigation.global-shortcuts.apps.opsgenie': 'Opsgenie',
  'navigation.global-shortcuts.apps.projects': 'Projecten',
  'navigation.global-shortcuts.apps.studio': 'Studio',
  'navigation.global-shortcuts.apps.talent': 'Talent',
  'navigation.global-shortcuts.apps.teams': 'Teams',
  'navigation.global-shortcuts.apps.trello': 'Trello',
  'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': 'Sluiten',
  'navigation.global-shortcuts.menu-expand-item.site-aria-label': '{name} site',
  'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': '(momenteel niet beschikbaar)',
  'navigation.global-shortcuts.menu-link-item.link-external-item-label': 'Pictogram voor een externe link openen',
  'navigation.global-shortcuts.menu-link-item.loading-item-aria-label': '(aan het laden)',
  'navigation.global-shortcuts.menu-loading-item.loading-item-aria-label': '(aan het laden)',
  'navigation.global-shortcuts.shortcut-action.open-menu-label': 'menu openen',
  'navigation.global-shortcuts.shortcut-link-item.aria-label': '{appName}{siteName}',
  'navigation.global-shortcuts.sites': '{productName}-sites',
};
